export { default } from "-!./View.ts?vue&type=script&lang=ts&external"; export * from "-!./View.ts?vue&type=script&lang=ts&external"